import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const HelpCenter: React.FC = () => {
  return (
    <PageTemplate
      title="Help Center"
      description="Find answers and get support"
    />
  );
};